import { render, staticRenderFns } from "./DashboardManagers.vue?vue&type=template&id=6d525d1a"
import script from "./DashboardManagers.vue?vue&type=script&lang=ts"
export * from "./DashboardManagers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d525d1a')) {
      api.createRecord('6d525d1a', component.options)
    } else {
      api.reload('6d525d1a', component.options)
    }
    module.hot.accept("./DashboardManagers.vue?vue&type=template&id=6d525d1a", function () {
      api.rerender('6d525d1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/DashboardManagers.vue"
export default component.exports